<template>
  <v-card class="users-list-card trezo-card border-radius d-block bg-white border-0 shadow-none">
    <div class="v-card-header d-flex align-items-center justify-content-between">
      <form class="search-box position-relative" @submit.prevent>
        <input
          type="text"
          class="input-search d-block"
          placeholder="Kullanıcı ara..."
          v-model="searchTerm"
          @input="onSearchInput"
        />
        <button type="submit">
          <i class="material-symbols-outlined">search</i>
        </button>
      </form>
      <v-btn color="primary" @click="openCreateDialog">
        <i class="material-symbols-outlined me-1">person_add</i>
        Yeni Kullanıcı Ekle
      </v-btn>
    </div>

    <div class="trezo-table-content">
      <div class="trezo-table">
        <v-table>
          <thead>
            <tr>
              <th class="text-start">Kullanıcı ID</th>
              <th class="text-start">Kullanıcı</th>
              <th class="text-start">Kullanıcı Adı</th>
              <th class="text-start">E-posta</th>
              <th class="text-start">Rol</th>
              <th class="text-start">Kayıt Tarihi</th>
              <th class="text-start">İşlem</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="item in filteredItems" :key="item.id">
              <td>{{ item.userID }}</td>

              <td>
                <div class="customer-info d-flex align-items-center">
                  <div class="img">
                    <v-img class="rounded-circle" :src="item.user.image" alt="user-image" />
                  </div>
                  <span class="d-block text-black fw-medium">
                    {{ item.user.name }}
                  </span>
                </div>
              </td>

              <td>{{ item.username }}</td>
              <td>{{ item.email }}</td>
              <td>
                <span
                  class="badge"
                  :class="item.role === 'admin' ? 'bg-danger' : 'bg-secondary'"
                  style="font-size:11px"
                >
                  {{ item.role === 'admin' ? 'Admin' : 'Kullanıcı' }}
                </span>
              </td>
              <td>{{ item.joinDate }}</td>

              <td>
                <div class="action-buttons d-flex align-items-center">
                  <button type="button" title="Görüntüle" @click="openUserDetails(item, false)">
                    <i class="material-symbols-outlined">{{ item.action.view }}</i>
                  </button>

                  <button type="button" title="Düzenle" @click="openUserDetails(item, true)">
                    <i class="material-symbols-outlined">{{ item.action.edit }}</i>
                  </button>

                  <button type="button" title="Sil" @click="deleteUser(item)">
                    <i class="material-symbols-outlined">{{ item.action.delete }}</i>
                  </button>
                </div>
              </td>
            </tr>

            <tr v-if="!loading && filteredItems.length === 0">
              <td colspan="7" class="text-center text-body">Kayıt bulunamadı.</td>
            </tr>
          </tbody>
        </v-table>

        <div v-if="loading" class="p-4 text-center text-body">Yükleniyor…</div>
        <div v-if="error" class="p-4 text-center" style="color:#c0392b">{{ error }}</div>

      </div>

      <!-- Pagination -->
      <div v-if="totalPages > 1" class="d-flex align-items-center justify-content-between px-4 py-3 border-top">
        <span class="text-body" style="font-size:13px">
          Toplam {{ totalUsers }} kullanıcı — Sayfa {{ currentPage }} / {{ totalPages }}
        </span>
        <div class="d-flex gap-2">
          <v-btn
            size="small"
            variant="outlined"
            :disabled="currentPage <= 1"
            @click="goToPage(currentPage - 1)"
          >Önceki</v-btn>
          <v-btn
            size="small"
            variant="outlined"
            :disabled="currentPage >= totalPages"
            @click="goToPage(currentPage + 1)"
          >Sonraki</v-btn>
        </div>
      </div>
    </div>

    <!-- USER DETAILS MODAL -->
    <v-dialog v-model="detailsDialog" max-width="1100" scrollable>
      <v-card class="border-radius">

        <div class="ud-header">
          <!-- LEFT -->
          <div class="ud-left">
            <v-img
              v-if="selectedUser?.user?.image"
              :src="selectedUser.user.image"
              width="44"
              height="44"
              class="rounded-circle ud-avatar"
            />

            <div class="ud-meta">
              <!-- VIEW -->
              <template v-if="!editMode">
                <div class="ud-name">
                  {{ selectedUser?.user?.name || "Kullanıcı" }}
                </div>

                <div class="ud-sub">
                  {{ selectedUser?.email || "—" }}
                  <span class="ud-dot">•</span>
                  {{ selectedUser?.userID || "" }}
                </div>
              </template>

              <!-- EDIT -->
              <template v-else>
                <div class="ud-edit-grid">
                  <v-text-field
                    v-model="editForm.user.name"
                    label="Ad Soyad"
                    density="compact"
                    variant="outlined"
                    hide-details
                  />
                  <v-text-field
                    v-model="editForm.user.username"
                    label="Kullanıcı Adı"
                    density="compact"
                    variant="outlined"
                    hide-details
                  />
                  <v-text-field
                    v-model="editForm.user.email"
                    label="E-posta"
                    density="compact"
                    variant="outlined"
                    hide-details
                    style="grid-column: 1 / -1"
                  />
                  <v-text-field
                    v-model="editForm.user.password"
                    label="Yeni Şifre (boş bırakılırsa değişmez)"
                    type="password"
                    density="compact"
                    variant="outlined"
                    hide-details
                    class="mt-2"
                    style="grid-column: 1 / -1"
                  />
                  <v-select
                    v-model="editForm.role"
                    :items="[{ title: 'Kullanıcı', value: 'user' }, { title: 'Admin', value: 'admin' }]"
                    label="Rol"
                    density="compact"
                    variant="outlined"
                    hide-details
                    class="mt-2"
                    style="grid-column: 1 / -1"
                  />
                </div>

                <div class="ud-sub mt-1">
                  {{ selectedUser?.userID || "" }}
                </div>
              </template>
            </div>
        </div>

        <!-- RIGHT -->
        <div class="ud-actions">
          <v-btn
            variant="outlined"
            density="comfortable"
            :loading="detailsLoading"
            :disabled="saveLoading"
            @click="reloadUserDetails"
          >
            Yenile
          </v-btn>

          <v-btn
            variant="outlined"
            density="comfortable"
            :loading="saveLoading"
            :disabled="detailsLoading"
            @click="toggleEditMode"
          >
            {{ editMode ? "Vazgeç" : "Düzenle" }}
          </v-btn>

          <v-btn
            v-if="editMode"
            color="primary"
            density="comfortable"
            :loading="saveLoading"
            :disabled="detailsLoading"
            @click="saveAll"
          >
            Kaydet
          </v-btn>

          <v-btn icon variant="text" :disabled="saveLoading" @click="detailsDialog = false">
            <i class="material-symbols-outlined">close</i>
          </v-btn>
        </div>
      </div>


        <v-card-text style="padding:0">
          <div v-if="detailsError" class="p-4" style="color:#c0392b">
            {{ detailsError }}
          </div>

          <div v-if="detailsLoading" class="p-4">
            <div class="text-body mb-3">Detaylar yükleniyor…</div>
            <v-skeleton-loader type="article, table, article" />
          </div>

          <div v-else class="p-4">
            <div class="d-flex align-center justify-space-between">
              <v-tabs v-model="detailsTab" density="comfortable">
                <v-tab value="quota">
                  <i class="material-symbols-outlined me-1" style="font-size:18px">speed</i>
                  Kota / Token
                </v-tab>
                <v-tab value="qa">
                  <i class="material-symbols-outlined me-1" style="font-size:18px">chat</i>
                  Soru / Cevap
                </v-tab>
              </v-tabs>
              <v-btn
                v-if="detailsTab === 'qa' && selectedUser?.username"
                variant="text"
                size="small"
                color="#1a5f4a"
                @click="openQaPage(selectedUser.username)"
              >
                <span class="material-symbols-outlined me-1" style="font-size:16px">open_in_new</span>
                Yeni sayfada aç
              </v-btn>
            </div>

            <v-window v-model="detailsTab" class="mt-3">
              <!-- QUOTA TAB -->
              <v-window-item value="quota">
                <div class="row g-3">
                  <div class="col-12 col-lg-12">
                    <v-card
                      class="trezo-card border-radius d-block bg-white border-0 shadow-none"
                      style="border:1px solid #eceef2"
                    >
                      <v-card-text>
                        <div class="d-flex align-items-center justify-content-between">
                          <div class="fw-semibold text-black">Soru Kotası</div>
                          <div class="text-body" style="font-size:12px">
                            Güncelleme: {{ fmtDate(details?.quota?.updated_at) }}
                          </div>
                        </div>

                        <div class="mt-3">
                          <div class="d-flex justify-content-between text-body" style="font-size:13px">
                            <span>Kullanılan</span>
                            <span>
                              {{ details?.quota?.used_count ?? 0 }} / {{ details?.quota?.total_limit ?? 0 }}
                              (Kalan: {{ details?.quota?.remaining ?? computedRemaining }})
                            </span>
                          </div>

                          <v-progress-linear class="mt-2" height="10" rounded :model-value="quotaPercent" />
                        </div>

                        <div class="mt-3 d-flex flex-wrap" style="gap:10px">
                          <span class="badge bg-light text-dark" style="border:1px solid #eceef2">
                            Toplam: <b>{{ details?.quota?.total_limit ?? 0 }}</b>
                          </span>
                          <span class="badge bg-light text-dark" style="border:1px solid #eceef2">
                            Kullanılan: <b>{{ details?.quota?.used_count ?? 0 }}</b>
                          </span>
                          <span class="badge bg-light text-dark" style="border:1px solid #eceef2">
                            Kalan: <b>{{ details?.quota?.remaining ?? computedRemaining }}</b>
                          </span>
                          <span class="badge bg-light text-dark" style="border:1px solid #eceef2">
                            Bugün: <b>{{ details?.quota?.asked_today ?? 0 }}</b> /
                            <b>{{ details?.quota?.effective_daily_limit ?? 0 }}</b>
                            <template v-if="details?.quota?.daily_limit != null"> (özel)</template>
                          </span>
                        </div>

                        <!-- EDIT QUOTA -->
                        <div
                          v-if="editMode"
                          class="mt-3"
                          style="border-top:1px dashed #eceef2; padding-top:14px"
                        >
                          <div class="row g-2">
                            <div class="col-12 col-md-4">
                              <v-text-field
                                v-model.number="editForm.quota.total_limit"
                                type="number"
                                min="0"
                                label="Toplam Limit"
                                density="compact"
                                variant="outlined"
                                hide-details
                              />
                            </div>

                            <div class="col-12 col-md-4">
                              <v-text-field
                                v-model.number="editForm.quota.used_count"
                                type="number"
                                min="0"
                                label="Kullanılan"
                                density="compact"
                                variant="outlined"
                                hide-details
                              />
                            </div>

                            <div class="col-12 col-md-4">
                              <v-text-field
                                :model-value="editRemaining"
                                label="Kalan (otomatik)"
                                density="compact"
                                variant="outlined"
                                hide-details
                                readonly
                              />
                            </div>

                            <div class="col-12 col-md-4">
                              <v-text-field
                                v-model.number="editForm.quota.daily_limit"
                                type="number"
                                min="0"
                                label="Günlük Limit (boş = varsayılan)"
                                density="compact"
                                variant="outlined"
                                hide-details
                                clearable
                              />
                            </div>
                          </div>

                          <div class="text-body mt-2" style="font-size:12px">
                            Not: remaining backend’de hesaplanıyorsa otomatik gelecektir.
                            Günlük Limit boş bırakılırsa sistem varsayılanı ({{ details?.quota?.default_daily_limit ?? 100 }}) uygulanır.
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </div>
              </v-window-item>

              <!-- Q/A TAB -->
              <v-window-item value="qa">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <div class="fw-semibold text-black">Soru / Cevap Geçmişi</div>
                  <div class="text-body" style="font-size:12px">
                    Kayıt: {{ details?.qa?.length ?? 0 }}
                  </div>
                </div>

                <div v-for="q in (details?.qa ?? [])" :key="q.id" class="qa-card">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <div class="text-body" style="font-size:12px">
                      {{ fmtDate(q.created_at) }}
                    </div>

                    <div class="d-flex align-items-center" style="gap:8px; flex-wrap:wrap">
                      <span class="badge bg-light text-dark" style="border:1px solid #eceef2">
                        doc_type: <b>{{ q.doc_type || "—" }}</b>
                      </span>
                      <span
                        v-if="(q.attachments?.length ?? 0) > 0"
                        class="badge bg-light text-dark"
                        style="border:1px solid #eceef2"
                      >
                        attachments: <b>{{ q.attachments?.length }}</b>
                      </span>
                    </div>
                  </div>

                  <div class="fw-semibold text-black mb-1">Soru</div>
                  <div class="text-body mb-3" style="white-space:pre-wrap">{{ q.question ?? "—" }}</div>

                  <div class="fw-semibold text-black mb-1">Cevap</div>

                  <!-- HTML olarak bas -->
                  <div class="text-body assistant-answer" v-if="q.answer" v-html="q.answer"></div>
                  <div v-else class="text-body">—</div>

                  <div v-if="(q.attachments?.length ?? 0) > 0" class="mt-3">
                    <div class="fw-semibold text-black mb-1">Attachments</div>
                    <div class="attachments">
                      <div v-for="(a, idx) in q.attachments" :key="idx" class="attachment-pill">
                        {{ stringifyAttachment(a) }}
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="(details?.qa?.length ?? 0) === 0" class="p-3 text-center text-body">
                  Soru/cevap kaydı bulunamadı.
                </div>
              </v-window-item>
            </v-window>
          </div>
        </v-card-text>

        <div class="px-4 py-3 d-flex justify-content-end" style="border-top:1px solid #eceef2">
          <v-btn variant="outlined" :disabled="saveLoading" @click="detailsDialog=false">Kapat</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- CREATE USER DIALOG -->
    <v-dialog v-model="createDialog" max-width="500" persistent>
      <v-card class="border-radius">
        <div class="d-flex align-items-center justify-content-between px-4 py-3" style="border-bottom: 1px solid #eceef2">
          <div class="fw-semibold text-black" style="font-size: 16px">Yeni Kullanıcı Ekle</div>
          <v-btn icon variant="text" @click="createDialog = false" :disabled="createLoading">
            <i class="material-symbols-outlined">close</i>
          </v-btn>
        </div>

        <v-card-text class="pt-4">
          <div v-if="createError" class="mb-3 p-3 bg-light" style="color: #c0392b; border-radius: 8px">
            {{ createError }}
          </div>

          <v-text-field
            v-model="createForm.name"
            label="Ad Soyad"
            variant="outlined"
            density="compact"
            class="mb-3"
            hide-details
            :disabled="createLoading"
          />

          <v-text-field
            v-model="createForm.username"
            label="Kullanıcı Adı"
            variant="outlined"
            density="compact"
            class="mb-3"
            hide-details
            :disabled="createLoading"
            hint="Sadece harf, rakam ve alt çizgi"
          />

          <v-text-field
            v-model="createForm.email"
            label="E-posta"
            type="email"
            variant="outlined"
            density="compact"
            class="mb-3"
            hide-details
            :disabled="createLoading"
          />

          <v-text-field
            v-model="createForm.password"
            label="Şifre"
            type="password"
            variant="outlined"
            density="compact"
            class="mb-3"
            hide-details
            :disabled="createLoading"
          />

          <v-select
            v-model="createForm.role"
            :items="[{ title: 'Kullanıcı', value: 'user' }, { title: 'Admin', value: 'admin' }]"
            label="Rol"
            variant="outlined"
            density="compact"
            hide-details
            :disabled="createLoading"
          />

          <div class="text-body mt-3" style="font-size: 12px">
            <i class="material-symbols-outlined me-1" style="font-size: 14px; vertical-align: middle">check_circle</i>
            E-posta otomatik olarak doğrulanmış kabul edilecektir.
          </div>
        </v-card-text>

        <div class="px-4 py-3 d-flex justify-content-end" style="border-top: 1px solid #eceef2; gap: 10px">
          <v-btn variant="outlined" :disabled="createLoading" @click="createDialog = false">İptal</v-btn>
          <v-btn color="primary" :loading="createLoading" @click="createUser">Kullanıcı Oluştur</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

type Row = {
  id: number | string;
  userID: string;
  user: {
    image: string;
    name: string;
  };
  username: string;
  email: string;
  phone: string;
  joinDate: string;
  location: string;
  projects: number;
  role: string;
  action: { view: string; edit: string; delete: string };
};

type ApiUser = {
  id: number | string;
  name: string | null;
  username: string | null;
  email: string | null;
  phone?: string | null;
  location?: string | null;
  projects_count?: number | null;
  created_at: string;
  avatar_url?: string | null;
  roles?: string[];
};

type UserDetailsResponse = {
  ok?: boolean;

  user?: {
    id: number | string;
    name?: string | null;
    username?: string | null;
    email?: string | null;
    roles?: string[];
  };

  quota?: {
    total_limit: number;
    used_count: number;
    remaining: number;
    daily_limit?: number | null;
    effective_daily_limit?: number;
    default_daily_limit?: number;
    asked_today?: number;
    updated_at?: string | null;
  };

  token_stats?: {
    prompt_tokens: number;
    response_tokens: number;
    total_tokens: number;
  };

  qa?: Array<{
    id: number | string;
    doc_type?: string | null;
    question?: string | null;
    answer?: string | null;
    attachments?: any[];
    created_at?: string | null;
  }>;
};

export default defineComponent({
  name: "UsersList",
  components: {},
  setup() {
    const router = useRouter();
    const items = ref<Row[]>([]);
    const loading = ref(false);
    const error = ref("");

    const searchTerm = ref("");
    const currentPage = ref(1);
    const totalPages = ref(1);
    const totalUsers = ref(0);
    let searchDebounceTimer: ReturnType<typeof setTimeout> | null = null;

    // modal state
    const detailsDialog = ref(false);
    const detailsLoading = ref(false);
    const detailsError = ref("");
    const detailsTab = ref<"quota" | "qa">("quota");
    const selectedUser = ref<Row | null>(null);
    const details = ref<UserDetailsResponse | null>(null);

    // edit state
    const editMode = ref(false);
    const saveLoading = ref(false);
    const editForm = ref({
      user: { name: "", username: "", email: "", password: "" },
      quota: { total_limit: 0, used_count: 0, daily_limit: null as number | null },
      role: "user",
    });

    // create user state
    const createDialog = ref(false);
    const createLoading = ref(false);
    const createError = ref("");
    const createForm = ref({
      name: "",
      username: "",
      email: "",
      password: "",
      role: "user",
    });

    const authHeaders = () => {
      const token = localStorage.getItem("auth_token");
      return {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "application/json",
      };
    };

    const fmtDate = (iso?: string | null) => {
      if (!iso) return "—";
      const d = new Date(iso);
      if (isNaN(d.getTime())) return "—";
      return new Intl.DateTimeFormat("tr-TR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      }).format(d);
    };

    const stringifyAttachment = (a: any) => {
      if (a == null) return "—";
      if (typeof a === "string") return a;
      if (typeof a === "number" || typeof a === "boolean") return String(a);
      if (typeof a === "object") return JSON.stringify(a);
      return String(a);
    };

    const fetchUsers = async (page = currentPage.value) => {
      loading.value = true;
      error.value = "";

      try {
        const params: Record<string, string | number> = { page };
        if (searchTerm.value.trim()) {
          params.search = searchTerm.value.trim();
        }

        const res = await axios.get(`${API_BASE_URL}/admin/users`, {
          headers: authHeaders(),
          params,
        });

        const list: ApiUser[] = Array.isArray(res.data?.data)
          ? res.data.data
          : Array.isArray(res.data)
          ? res.data
          : [];

        totalUsers.value  = res.data?.total ?? list.length;
        totalPages.value  = res.data?.last_page ?? 1;
        currentPage.value = res.data?.current_page ?? page;

        items.value = list.map((u: ApiUser) => {
          const displayName = u.name || (u.email ? String(u.email).split("@")[0] : "Bilinmeyen Kullanıcı");
          const avatar =
            u.avatar_url ||
            `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName)}&background=random`;

          const joinDate = u.created_at ? fmtDate(u.created_at) : "—";

          return {
            id: u.id,
            userID: `#${String(u.id).slice(0, 6)}`,
            user: { image: avatar, name: displayName },
            username: u.username || "—",
            email: u.email || "—",
            phone: u.phone || "—",
            joinDate,
            location: u.location || "—",
            projects: u.projects_count ?? 0,
            role: u.roles?.includes("admin") ? "admin" : "user",
            action: { view: "visibility", edit: "edit", delete: "delete" },
          } as Row;
        });
      } catch (e: any) {
        error.value = e?.response?.data?.message || e?.message || "Liste alınırken bir hata oluştu.";
      } finally {
        loading.value = false;
      }
    };

    const onSearchInput = () => {
      if (searchDebounceTimer) clearTimeout(searchDebounceTimer);
      searchDebounceTimer = setTimeout(() => {
        currentPage.value = 1;
        fetchUsers(1);
      }, 400);
    };

    const goToPage = (page: number) => {
      if (page < 1 || page > totalPages.value) return;
      fetchUsers(page);
    };

    const fetchUserDetails = async (userId: number | string) => {
      detailsLoading.value = true;
      detailsError.value = "";
      details.value = null;

      try {
        const res = await axios.get(`${API_BASE_URL}/admin/users/${userId}/details`, {
          headers: authHeaders(),
        });

        details.value = (res.data || {}) as UserDetailsResponse;
      } catch (e: any) {
        console.error("fetchUserDetails error", e);
        detailsError.value = e?.response?.data?.message || e?.message || "Kullanıcı detayları alınırken hata oluştu.";
      } finally {
        detailsLoading.value = false;
      }
    };

    const hydrateEditForm = () => {
      editForm.value.user.name = details.value?.user?.name || selectedUser.value?.user?.name || "";
      editForm.value.user.username = details.value?.user?.username || selectedUser.value?.username || "";
      editForm.value.user.email = details.value?.user?.email || selectedUser.value?.email || "";
      editForm.value.user.password = "";
      editForm.value.quota.total_limit = details.value?.quota?.total_limit ?? 0;
      editForm.value.quota.used_count = details.value?.quota?.used_count ?? 0;
      editForm.value.quota.daily_limit = details.value?.quota?.daily_limit ?? null;
      editForm.value.role = details.value?.user?.roles?.includes("admin") ? "admin" : "user";
    };


    const openUserDetails = async (row: Row, mode: boolean) => {
      selectedUser.value = row;
      detailsTab.value = "quota";
      detailsDialog.value = true;

      editMode.value = mode;
      await fetchUserDetails(row.id);
      hydrateEditForm();
    };

    const deleteUser = async (row: Row) => {
      if (!confirm("Kullanıcı silinsin mi?")) return;

      try {
        await axios.delete(`${API_BASE_URL}/admin/users/${row.id}`, { headers: authHeaders() });
        await fetchUsers();
      } catch (e: any) {
        alert(e?.response?.data?.message || e?.message || "Silme hatası");
      }
    };

    const openCreateDialog = () => {
      createForm.value = { name: "", username: "", email: "", password: "", role: "user" };
      createError.value = "";
      createDialog.value = true;
    };

    const createUser = async () => {
      if (!createForm.value.name || !createForm.value.username || !createForm.value.email || !createForm.value.password) {
        createError.value = "Tüm alanları doldurunuz.";
        return;
      }

      createLoading.value = true;
      createError.value = "";

      try {
        await axios.post(
          `${API_BASE_URL}/admin/users`,
          {
            name: createForm.value.name,
            username: createForm.value.username,
            email: createForm.value.email,
            password: createForm.value.password,
            role: createForm.value.role,
          },
          { headers: authHeaders() }
        );

        createDialog.value = false;
        await fetchUsers();
      } catch (e: any) {
        console.error("createUser error", e);
        createError.value = e?.response?.data?.message || e?.message || "Kullanıcı oluşturulurken hata oluştu.";
      } finally {
        createLoading.value = false;
      }
    };

    const reloadUserDetails = async () => {
      if (!selectedUser.value) return;
      editMode.value = false;
      await fetchUserDetails(selectedUser.value.id);
      hydrateEditForm();
    };

    const toggleEditMode = () => {
      editMode.value = !editMode.value;
      if (editMode.value) hydrateEditForm();
    };

    const saveUserOnly = async (userId: number | string) => {
      const payload: { name: string; username: string; email: string; password?: string } = {
        name: editForm.value.user.name,
        username: editForm.value.user.username,
        email: editForm.value.user.email,
      };

      // Şifre girilmişse ekle
      if (editForm.value.user.password && editForm.value.user.password.trim()) {
        payload.password = editForm.value.user.password;
      }

      await axios.put(
        `${API_BASE_URL}/admin/users/${userId}`,
        payload,
        { headers: authHeaders() }
      );
    };

    const saveQuotaOnly = async (userId: number | string) => {
      const total = Number(editForm.value.quota.total_limit ?? 0);
      const used = Number(editForm.value.quota.used_count ?? 0);
      const safeTotal = Math.max(0, total);
      const safeUsed = Math.max(0, Math.min(used, safeTotal));

      // Boş bırakılırsa null → kişiye özel override kaldırılır, varsayılan geçerli olur.
      const dailyRaw = editForm.value.quota.daily_limit;
      const daily =
        dailyRaw === null || dailyRaw === undefined || (dailyRaw as unknown as string) === ""
          ? null
          : Math.max(0, Number(dailyRaw));

      await axios.put(
        `${API_BASE_URL}/admin/users/${userId}/quota`,
        {
          total_limit: safeTotal,
          used_count: safeUsed,
          daily_limit: daily,
        },
        { headers: authHeaders() }
      );
    };

    const saveAll = async () => {
      if (!selectedUser.value) return;

      saveLoading.value = true;
      detailsError.value = "";

      try {
        await saveUserOnly(selectedUser.value.id);
        await saveQuotaOnly(selectedUser.value.id);
        await axios.put(
          `${API_BASE_URL}/admin/users/${selectedUser.value.id}/role`,
          { role: editForm.value.role },
          { headers: authHeaders() }
        );

        await fetchUserDetails(selectedUser.value.id);
        await fetchUsers();
        hydrateEditForm();

        editMode.value = false;
      } catch (e: any) {
        console.error("saveAll error", e);
        detailsError.value = e?.response?.data?.message || e?.message || "Kaydetme sırasında hata oluştu.";
      } finally {
        saveLoading.value = false;
      }
    };

    const filteredItems = computed(() => items.value);

    const computedRemaining = computed(() => {
      const total = details.value?.quota?.total_limit ?? 0;
      const used = details.value?.quota?.used_count ?? 0;
      return Math.max(0, total - used);
    });

    const quotaPercent = computed(() => {
      const total = details.value?.quota?.total_limit ?? 0;
      const used = details.value?.quota?.used_count ?? 0;
      if (!total) return 0;
      return Math.min(100, Math.round((used / total) * 100));
    });

    const editRemaining = computed(() => {
      const total = Number(editForm.value.quota.total_limit ?? 0);
      const used = Number(editForm.value.quota.used_count ?? 0);
      return Math.max(0, total - used);
    });

    onMounted(() => {
      fetchUsers();
    });

    return {
      items,
      loading,
      error,
      searchTerm,
      filteredItems,
      currentPage,
      totalPages,
      totalUsers,
      onSearchInput,
      goToPage,

      // modal
      detailsDialog,
      detailsLoading,
      detailsError,
      detailsTab,
      selectedUser,
      details,

      // edit
      editMode,
      saveLoading,
      editForm,
      toggleEditMode,
      saveAll,

      // create
      createDialog,
      createLoading,
      createError,
      createForm,
      openCreateDialog,
      createUser,

      // methods
      openUserDetails,
      deleteUser,
      reloadUserDetails,
      fmtDate,
      stringifyAttachment,
      openQaPage: (username: string | null) => {
        if (!username) return;
        router.push({ path: `/admin/users/${username}/questions` });
      },
      // computed
      computedRemaining,
      quotaPercent,
      editRemaining,
    };

  },
});
</script>

<style lang="scss" scoped>
.users-list-card {
  padding-bottom: 8px !important;

  .trezo-table-content {
    .trezo-table {
      margin-left: -25px;
      margin-right: -25px;

      table {
        thead tr th {
          background-color: #ecf0ff !important;
          padding-top: 13px;
          padding-bottom: 13px;

          &:first-child {
            padding-left: 25px;
          }
          &:last-child {
            padding-right: 25px;
          }

          .v-input__details {
            display: none !important;
          }
          .v-selection-control__input {
            width: 0 !important;
            height: 0 !important;
          }
        }

        tbody tr td {
          padding-top: 17px !important;
          padding-bottom: 17px !important;

          &:first-child {
            padding-left: 25px;
          }
          &:last-child {
            padding-right: 25px;
          }

          .v-input__details {
            display: none !important;
          }
          .v-selection-control__input {
            width: 0 !important;
            height: 0 !important;
          }
        }

        tbody tr:last-child td {
          border-bottom-width: 0;
        }
        tbody tr:first-child td {
          border-top-width: 0;
        }
      }

      .pagination-content {
        margin-top: 0;
        padding: 15px 20px;
        border-radius: 0 0 7px 7px;
        color: var(--blackColor) !important;
        background-color: transparent !important;
        border-top: 1px solid #eceef2;
      }
    }
  }
}

.qa-card {
  border: 1px solid #eceef2;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 12px;
  background: #fff;
}

.attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.attachment-pill {
  border: 1px solid #eceef2;
  background: #f8f9fb;
  color: #2c3e50;
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 12px;
}

.assistant-answer {
  white-space: normal;
  line-height: 1.55;

  p {
    margin: 0 0 10px;
  }
  ul,
  ol {
    margin: 0 0 10px 18px;
  }
  li {
    margin: 4px 0;
  }
  a {
    text-decoration: underline;
  }
  code {
    padding: 2px 6px;
    border-radius: 6px;
    background: #f4f6f9;
  }
  pre {
    padding: 10px;
    border-radius: 10px;
    background: #f4f6f9;
    overflow: auto;
  }
}


.ud-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border-bottom: 1px solid #eceef2;

  /* önemli: flex çocuklarının taşmasını engelle */
  min-width: 0;
}

/* ✅ SOL KISIM %50 SABİT */
.ud-left {
  flex: 0 0 50%;
  width: 50%;
  max-width: 50%;

  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0; /* ellipsis için şart */
}

/* ✅ SAĞ KISIM %50 SABİT */
.ud-actions {
  flex: 0 0 50%;
  width: 50%;
  max-width: 50%;

  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
  min-width: 0;
}

/* avatar */
.ud-avatar {
  flex: 0 0 auto;
  border: 1px solid #eceef2;
}

/* meta alanı taşmaları düzgün yönetsin */
.ud-meta {
  flex: 1 1 auto;
  min-width: 0;
}

.ud-name {
  font-weight: 600;
  color: #111;
  font-size: 15px;
  line-height: 1.2;
}

.ud-sub {
  color: #6b7280;
  font-size: 12px;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.ud-dot {
  margin: 0 6px;
  opacity: 0.7;
}

.ud-badges {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.ud-mini {
  font-size: 12px;
  color: #6b7280;
}

/* ✅ EDIT grid: input’lar küçülmesin diye minmax(0, 1fr) */
.ud-edit-grid {
  margin-top: 6px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 10px;
  align-items: start;
  width: 100%;
}

/* v-text-field tam genişlik */
.ud-edit-grid :deep(.v-input) {
  width: 100%;
  min-width: 0;
}

/* ✅ Verify kutusu ayrı satırda, input grid’ini etkilemesin */
.ud-verify-box {
  grid-column: 1 / -1;
  border: 1px solid #eceef2;
  background: #fafbfc;
  border-radius: 10px;
  padding: 10px 12px;
  min-width: 0;
}

.ud-verify-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
}

.ud-verify-title {
  font-weight: 600;
  color: #111;
  font-size: 13px;
  white-space: nowrap;
}

.ud-verify-sub {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
}

/* switch track görünürlüğü */
.ud-switch :deep(.v-switch__track) {
  opacity: 1;
}

/* ✅ mobil */
@media (max-width: 768px) {
  .ud-header {
    flex-direction: column;
  }

  .ud-left,
  .ud-actions {
    flex: 0 0 auto;
    width: 100%;
    max-width: 100%;
  }

  .ud-actions {
    justify-content: flex-start;
  }

  .ud-edit-grid {
    grid-template-columns: 1fr;
  }
}


</style>
